import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { issuedInvoicesTranslationKeys } from '../translations';

import { IssuedInvoicesPanel } from './IssuedInvoicesPanel';

type IssuedInvoicesNavTab<PARAM_NAME extends string> = {
   param: PARAM_NAME;
   label: TranslatableText;
   content: ReactElement;
};

type UseIssuedInvoicesNavTabOptions<PARAM_NAME> = {
   param: PARAM_NAME;
};

export const useIssuedInvoicesNavTab = <PARAM_NAME extends string>(
   options: UseIssuedInvoicesNavTabOptions<PARAM_NAME>
): IssuedInvoicesNavTab<PARAM_NAME> | null => {
   return protectFeature(
      'creatingInvoices',
      {
         content: <IssuedInvoicesPanel />,
         label: issuedInvoicesTranslationKeys.tabName,
         param: options.param,
      },
      null
   );
};
